import { css } from "lit";
import { concatClasses } from "../helpers/concatClasses/index.js";
const placements = [
  "top",
  "right",
  "bottom",
  "left",
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end",
  "right-start",
  "right-end",
  "left-start",
  "left-end"
];
function getArrowClasses({ dsf_placement }) {
  const classes = [];
  if (dsf_placement.startsWith("bottom")) {
    classes.push("arrow-top");
  } else if (dsf_placement.startsWith("top")) {
    classes.push("arrow-bottom");
  } else if (dsf_placement.startsWith("left")) {
    classes.push("arrow-right");
  } else if (dsf_placement.startsWith("right")) {
    classes.push("arrow-left");
  }
  return concatClasses(classes);
}
const arrowStyles = css`
  #arrow {
    position: absolute;
    width: 0;
    height: 0;

    --dsf-arrow-size: calc(0.8 * var(--dsf-base-size));
    --dsf-border-width: calc(1 / 8 * var(--dsf-arrow-size));
    --dsf-arrow-offset: calc(var(--dsf-arrow-size) - var(--dsf-border-width));
  }

  #arrow::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: calc(-1 * var(--dsf-arrow-offset));
    top: var(--dsf-border-width);
  }

  #arrow.arrow-bottom {
    border-left: var(--dsf-arrow-size) solid transparent;
    border-right: var(--dsf-arrow-size) solid transparent;
    border-top: var(--dsf-arrow-size) solid var(--dsf-arrow-border-color);
  }

  #arrow.arrow-bottom::before {
    border-left: var(--dsf-arrow-offset) solid transparent;
    border-right: var(--dsf-arrow-offset) solid transparent;
    border-top: var(--dsf-arrow-offset) solid var(--dsf-arrow-color);
    top: calc(-1 * var(--dsf-arrow-size));
  }

  #arrow.arrow-top {
    border-left: var(--dsf-arrow-size) solid transparent;
    border-right: var(--dsf-arrow-size) solid transparent;
    border-bottom: var(--dsf-arrow-size) solid var(--dsf-arrow-border-color);
  }

  #arrow.arrow-top::before {
    border-left: var(--dsf-arrow-offset) solid transparent;
    border-right: var(--dsf-arrow-offset) solid transparent;
    border-bottom: var(--dsf-arrow-offset) solid var(--dsf-arrow-color);
  }

  #arrow.arrow-right {
    border-top: var(--dsf-arrow-size) solid transparent;
    border-left: var(--dsf-arrow-size) solid var(--dsf-arrow-border-color);
    border-bottom: var(--dsf-arrow-size) solid transparent;
  }

  #arrow.arrow-right::before {
    border-top: var(--dsf-arrow-offset) solid transparent;
    border-left: var(--dsf-arrow-offset) solid var(--dsf-arrow-color);
    border-bottom: var(--dsf-arrow-offset) solid transparent;
    top: calc(-1 * var(--dsf-arrow-offset));
    left: calc(-1 * var(--dsf-arrow-size));
  }

  #arrow.arrow-left {
    border-top: var(--dsf-arrow-size) solid transparent;
    border-right: var(--dsf-arrow-size) solid var(--dsf-arrow-border-color);
    border-bottom: var(--dsf-arrow-size) solid transparent;
  }

  #arrow.arrow-left::before {
    border-top: var(--dsf-arrow-offset) solid transparent;
    border-right: var(--dsf-arrow-offset) solid var(--dsf-arrow-color);
    border-bottom: var(--dsf-arrow-offset) solid transparent;
    top: calc(-1 * var(--dsf-arrow-offset));
    left: var(--dsf-border-width);
  }
`;
export {
  arrowStyles,
  getArrowClasses,
  placements
};
